export const iconFontAwesomeFilesFileAudio = (
	<i className="fa-solid fa-file-audio"></i>
);
